var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomethingElse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.37 19.02H28.09C27.742 19.02 27.46 19.302 27.46 19.65V44.25C27.46 44.5979 27.742 44.88 28.09 44.88H55.37C55.7179 44.88 56 44.5979 56 44.25V19.65C56 19.302 55.7179 19.02 55.37 19.02Z",
    fill: "#EBA183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.63 33.9L27.46 35.78V44.25C27.46 44.417 27.5263 44.5773 27.6445 44.6954C27.7626 44.8136 27.9229 44.88 28.09 44.88H53.56L28.63 33.9Z",
    fill: "#BC8169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.63 19H45.83V25C45.83 25.1826 45.794 25.3633 45.7242 25.532C45.6543 25.7006 45.552 25.8538 45.4229 25.9829C45.2938 26.112 45.1406 26.2144 44.9719 26.2842C44.8033 26.3541 44.6225 26.39 44.44 26.39H39C38.6348 26.3848 38.2864 26.236 38.03 25.9759C37.7737 25.7158 37.63 25.3652 37.63 25V19Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38.33L29 35.93C29.1405 35.5962 29.1794 35.2284 29.1118 34.8727C29.0442 34.5169 28.8731 34.189 28.62 33.93C28.2771 33.5893 27.8134 33.398 27.33 33.398C26.8466 33.398 26.3829 33.5893 26.04 33.93L21 39C18.8081 41.1814 15.8424 42.4073 12.75 42.41H8V55.22H29.18C30.9776 55.2206 32.7478 54.7806 34.336 53.9386C35.9241 53.0965 37.2817 51.8782 38.29 50.39L40.86 46.6C41.4392 45.7329 42.163 44.9719 43 44.35C43.3064 44.127 43.5564 43.8354 43.7301 43.4986C43.9037 43.1618 43.9961 42.789 44 42.41C44 42.0935 43.9377 41.7801 43.8166 41.4877C43.6954 41.1953 43.5179 40.9297 43.2941 40.7059C43.0703 40.4821 42.8047 40.3046 42.5123 40.1835C42.2199 40.0623 41.9065 40 41.59 40H29.05C28.8554 39.9937 28.6652 39.9397 28.4963 39.8428C28.3274 39.7458 28.1849 39.6089 28.0812 39.444C27.9775 39.2792 27.9159 39.0914 27.9018 38.8971C27.8876 38.7029 27.9213 38.5082 28 38.33Z",
    fill: "#DFE8F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.73 42.3901H10.25V55.2201H13.94V42.3301C13.5379 42.3703 13.1341 42.3903 12.73 42.3901Z",
    fill: "#CCD8E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 41.3701H10.89C11.1048 41.3701 11.3109 41.4555 11.4628 41.6074C11.6147 41.7593 11.7 41.9653 11.7 42.1801V55.1801C11.7 55.395 11.6147 55.601 11.4628 55.7529C11.3109 55.9048 11.1048 55.9902 10.89 55.9902H8V41.3701Z",
    fill: "#EBA183"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingElse);
export default __webpack_public_path__ + "static/media/something-else.96455f9104b46afaae7ba45764f47c89.svg";
export { ForwardRef as ReactComponent };